import styled from 'styled-components'
import { colors } from 'client/styles'
import { SIZE_SMALL, SIZE_MEDIUM, SIZE_BIG, VARIANT_SQUARE } from './constants'
import type { variantsType } from './types'

export const ScoreBase = styled.span`
  display: flex;
  font-weight: 700;
  line-height: 1.2;
  align-items: center;
  grid-area: score;
`

export const ScoreRating = styled.span<{
  variant: variantsType
  color: string
  size: string
  asymetricRoundedShape: boolean
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${props => (props.variant === VARIANT_SQUARE ? props.color : 'transparent')};
  border-start-start-radius: ${props => (props.asymetricRoundedShape ? '8px' : '5px')};
  border-start-end-radius: ${props => (props.asymetricRoundedShape ? '8px' : '5px')};
  border-end-end-radius: ${props => (props.asymetricRoundedShape ? '8px' : '5px')};
  border-end-start-radius: ${props => (props.asymetricRoundedShape ? '2px' : '5px')};

  color: ${props => (props.variant === VARIANT_SQUARE ? colors.white : props.color)};

  ${props =>
    props.size === SIZE_SMALL && props.asymetricRoundedShape
      ? 'font-size: 14px; width: 32px; height: 32px'
      : 'font-size: 12px; width: 26px; height: 26px;'}
  ${props => props.size === SIZE_MEDIUM && 'font-size: 16px; width: 35px; height: 35px;'}
  ${props => props.size === SIZE_BIG && 'font-size: 21px; width: 50px; height: 50px;'}
`

export const Category = styled.span<{ color: string; size: string }>`
  color: ${props => props.color};
  display: flex;
  font-weight: 700;
  text-transform: capitalize;
  margin-inline-start: 10px;

  ${props => props.size === SIZE_SMALL && 'font-size: 16px;'}
  ${props => props.size === SIZE_MEDIUM && 'font-size: 16px;'}
  ${props => props.size === SIZE_BIG && 'font-size: 21px;'}
`
